<template>
    <div class='ads'>
        <img src='/img/ads.svg' alt='image'/>
    </div>
</template>
<script>
export default {
    name: 'SideImage',
    data(){
        return {

        }
    },
   
}
</script>